import { useCallback } from 'react';
import styled from 'styled-components';
import AddIcon from '../assets/add.svg?react';
import { useCustomMusic } from '../data/use_custom_music.tsx';
import { useUserAttributes } from '../data/use_user_attributes.ts';
import { PlannerButtonIconThreshold } from '../pages/admin/org/shared.tsx';
import { addCustomSong } from './add_song.tsx';
import { getPlatform, Platform } from './platform.ts';

export const UploadSongButton = () => {
  const { customMusic, customMusicManifest } = useCustomMusic();

  const onClick = useCallback(async () => {
    await addCustomSong({ customMusic, customMusicManifest });
  }, [customMusic, customMusicManifest]);

  const { isInternalUser, isOrgAdmin } = useUserAttributes();
  if (!isInternalUser && !isOrgAdmin) {
    return;
  }

  return (
    <UploadSongButtonWrapper onClick={onClick} $isMobile={getPlatform() === Platform.Mobile}>
      <AddIconText>Add Song</AddIconText>
      <AddIconWrapper />
    </UploadSongButtonWrapper>
  );
};

export const HeaderButtonPaddingDesktop = '3px 10px';
export const HeaderButtonBorderRadius = '30px';

const UploadSongButtonWrapper = styled.button<{ $isMobile: boolean }>`
  z-index: 1;
  color: var(--color-text-button-onboarding-primary);
  background-color: var(--color-primary-button);
  border-color: var(--color-primary-button);
  font-family: Jost-SemiBold, Arial, sans-serif;
  padding: ${HeaderButtonPaddingDesktop};
  @media (max-width: ${PlannerButtonIconThreshold}) {
    padding: 2.5px;
  }
  border-radius: ${HeaderButtonBorderRadius};
  cursor: pointer;
  text-wrap: nowrap;
`;

const AddIconWrapper = styled(AddIcon)`
  width: 25px;
  color: var(--color-background);
  @media (min-width: ${PlannerButtonIconThreshold}) {
    display: none;
  }
`;

const AddIconText = styled.div`
  @media (max-width: ${PlannerButtonIconThreshold}) {
    display: none;
  }
`;
